"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _hitagiJs = _interopRequireDefault(require("hitagi-js"));
var _hitagi_connector = _interopRequireDefault(require("hitagi-js/build/hitagi_connector"));
var _index = _interopRequireDefault(require("../registry/index"));
var _index2 = require("../locale/index");
var _index3 = _interopRequireDefault(require("../3rdparty/bbcode/index"));
var _index4 = require("../interfaces/site/index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var HitagiSocket;
var HitagiReConnector;
var awaitingForConversationUid = 0;
function on_local_stream_success(store, conversation_uid, call_id) {
  return function (LocalMediaStream) {
    console.log("LocalMediaStream", LocalMediaStream);
    var MediaStreamTracks = LocalMediaStream.getTracks();
    MediaStreamTracks.map(function (MediaStreamTrack) {
      if (MediaStreamTrack.kind == 'video') {
        MediaStreamTrack.onended = function () {
          HitagiSocket.log('Media streaming STOPPED.');
          HitagiSocket.stream.stop();
        };
      }
    });
    LocalMediaStream["private"] = true;
    LocalMediaStream.call_id = call_id;
    HitagiSocket.stream.start(LocalMediaStream, function () {
      store.dispatch({
        type: "PM_VIDEO_CALL_GET_LOCAL_STREAM_SUCCESS",
        stream: LocalMediaStream,
        call_id: call_id,
        conversation_uid: conversation_uid
      });
      store.dispatch({
        type: "PM_ACTION_VIDEO_CALL_TOGGLE_MIC",
        on: true,
        conversation_uid: conversation_uid,
        call_id: call_id
      });
    });
  };
}
var pmMiddleware = function pmMiddleware(store) {
  return function (next) {
    return function (action) {
      switch (action.type) {
        case "PM_CONNECT_TO_SERVER":
          var chatroom = action.chatroom_name ? action.chatroom_name : "";
          var localeCode = document.location.pathname.includes('/en/') ? 'en' : document.location.pathname.includes('/ru/') ? 'ru' : 'fr';
          var locale = (0, _index2.loadLocale)(localeCode);
          if (_index["default"].exists('locale')) {
            _index["default"].remove('locale');
          }
          if (_index["default"].exists('siteInterface')) {
            _index["default"].remove('siteInterface');
          }
          if (!_index["default"].exists('locale')) {
            _index["default"].add({
              locale: locale
            });
          }
          if (!_index["default"].exists('siteInterface')) {
            var siteInterface = new _index4.BobTVSiteInterface(locale.path);
            siteInterface.setAuthParams({
              uid: action.user.uid
            });
            _index["default"].add({
              siteInterface: siteInterface
            });
          }
          var currentUserUid = action.user.id;
          HitagiSocket = new _hitagiJs["default"]({
            'ServerUri': action.url,
            ChatroomName: chatroom
          });
          HitagiSocket.on("im:conversations", function (evt) {
            store.dispatch({
              type: "PM_CONVERSATIONS",
              data: evt
            });
            store.dispatch({
              type: "PM_CHANGE_CONNECTION_STATUS",
              status: "connected"
            });
          });
          HitagiSocket.on("im:message", function (Message) {
            var uid = Message.sender_uid !== currentUserUid ? Message.sender_uid : Message.receiver_uid;
            var messageText = (0, _index3["default"])(Message.message, {
              extractAttachments: true
            });
            store.dispatch({
              type: "PM_MESSAGE",
              message: _objectSpread(_objectSpread({}, Message), {}, {
                rendered: messageText
              }),
              conversation_uid: uid,
              uid: uid
            });
          });
          HitagiSocket.on("im:conversation_changed", function (Data) {
            store.dispatch({
              type: "PM_CONVERSATION_CHANGED",
              conversation_uid: Data.recipient_uid,
              data: Data
            });
          });
          HitagiSocket.on("im:user_update", function (Data) {
            if (Data.user.uid == currentUserUid) {
              store.dispatch({
                type: "PM_MY_USER_UPDATE",
                user: Data.user,
                conversation_uid: Data.user.uid
              });
            } else {
              store.dispatch({
                type: "PM_USER_UPDATE",
                user: Data.user,
                conversation_uid: Data.user.uid
              });
            }
          });

          // server-originated actions
          //HitagiSocket.on("im:access_request", function(Request){ console.log("access request", Request); store.dispatch({type: "PM_ACCESS_REQUEST", conversation_uid: Request.from_uid, request: Request}) });

          HitagiSocket.on("im:typing_notify", function (Notify) {
            store.dispatch({
              type: "PM_TYPING_NOTIFY",
              notification: Notify,
              conversation_uid: Notify.from
            });
            setTimeout(function () {
              store.dispatch({
                type: "PM_CLEAR_TYPING_NOTIFY",
                conversation_uid: Notify.from
              });
            }, 5000);
          });
          HitagiSocket.on("im:history_deleted", function (DeleteHistory) {
            store.dispatch({
              type: "PM_DELETE_HISTORY",
              deleteHistory: DeleteHistory,
              conversation_uid: DeleteHistory.from_uid
            });
            store.dispatch({
              type: "SIDEBAR_RIGHT_HIDE"
            });
          });
          HitagiSocket.on("close", function () {
            store.dispatch({
              type: "PM_CHANGE_CONNECTION_STATUS",
              status: "disconnected"
            });
          });
          HitagiSocket.on("im:video_call_info", function (Call) {
            store.dispatch({
              type: "PM_VIDEO_CALL_INFO",
              conversation_uid: Call.conversation_uid,
              call: Call
            });
          });
          store.dispatch({
            type: "PM_CHANGE_CONNECTION_STATUS",
            status: "connecting"
          });
          HitagiSocket.login({}, function (e) {}, function (e, comment) {
            if (comment == "unauthorized") {
              HitagiReConnector.disable_reconnect();
            }
          });
          HitagiReConnector = new _hitagi_connector["default"](HitagiSocket);
          break;
        case "PM_DISCONNECT_FROM_SERVER":
          if (HitagiReConnector) {
            HitagiReConnector.disable_reconnect();
          }
          HitagiSocket.logout();
          break;
        case "PM_SESSION_START":
          var uid = action.conversation_uid;
          if (store.getState().pm.conversations[uid]) {
            store.dispatch({
              type: "PM_WINDOW_MAXIMIZE",
              conversation_uid: uid
            });
          } else {
            store.dispatch({
              type: "PM_PERFORM_PM_REQUEST",
              conversation_uid: uid
            });
          }
          ;
          break;
        case "PM_ACTION_LOAD_MESSAGES":
          HitagiSocket.im.load_messages(action.conversation_uid, action.direction, action.filter_id, function (Data) {
            var History = Data.history;
            store.dispatch({
              type: "PM_ACTION_LOAD_MESSAGES_SUCCESS",
              history: Data.history,
              conversation_uid: action.conversation_uid
            });
          });
          break;
        case "PM_ACTION_DELETE_HISTORY":
          HitagiSocket.im.delete_history(action.conversation_uid);
          break;
        case "PM_ACTION_REVOKE_PERMISSION":
        case "PM_DENY_PM_REQUEST":
          HitagiSocket.im.access_deny(action.conversation_uid);
          store.dispatch({
            type: "PM_SESSION_HIDE",
            conversation_uid: action.conversation_uid
          });
          break;
        case "PM_ACCEPT_PM_REQUEST":
          HitagiSocket.im.access_allow(action.conversation_uid);
          break;
        case "PM_CANCEL_PM_REQUEST":
          HitagiSocket.im.access_reset(action.conversation_uid);
          break;
        case "PM_PERFORM_PM_REQUEST":
          HitagiSocket.im.access_request(action.conversation_uid);
          awaitingForConversationUid = action.conversation_uid;
          break;
        case "PM_SEND_MESSAGE":
          HitagiSocket.im.markRead(action.conversation_uid);
          HitagiSocket.im.post_message(action.message_text, action.conversation_uid);
          break;
        case "PM_WINDOW_MAXIMIZE":
          HitagiSocket.im.markRead(action.conversation_uid);
          break;
        case "PM_SEND_TYPING_NOTIFY":
          HitagiSocket.im.send_typing_notify(action.conversation_uid);
          break;
        case "PM_MARK_READ":
          HitagiSocket.im.markRead(action.conversation_uid);
          break;
        case "PM_CONVERSATION_CHANGED":
          next(action);
          if (action.conversation_uid == awaitingForConversationUid) {
            store.dispatch({
              type: "PM_WINDOW_MAXIMIZE",
              conversation_uid: action.conversation_uid
            });
            awaitingForConversationUid = 0;
          }
          return;
        case "PM_ACTION_VIDEO_CALL_START":
          HitagiSocket.action("im", "video_call_start", {
            "to": action.conversation_uid
          }, function () {}, function (E1, E2, E3) {
            store.dispatch({
              type: "PM_ACTION_VIDEO_CALL_START_ERROR",
              conversation_uid: action.conversation_uid,
              reason: E2
            });
            console.log("Video call start fail, reason: ", E1, E2, E3);
          });
          break;
        case "PM_ACTION_VIDEO_CALL_CANCEL":
          HitagiSocket.action("im", "video_call_cancel", {
            "call_id": action.call_id
          });
          break;
        case "PM_ACTION_VIDEO_CALL_DECLINE":
          HitagiSocket.action("im", "video_call_decline", {
            "call_id": action.call_id
          });
          break;
        case "PM_ACTION_VIDEO_CALL_ANSWER":
          HitagiSocket.action("im", "video_call_answer", {
            "call_id": action.call_id
          });
          store.dispatch({
            type: "PM_VIDEO_CALL_GET_LOCAL_MEDIA_STREAM",
            conversation_uid: action.conversation_uid,
            call_id: action.call_id
          });
          break;
        case "PM_ACTION_VIDEO_CALL_END_CALL":
          HitagiSocket.action("im", "video_call_end_call", {
            "call_id": action.call_id
          });
          break;
        case "PM_ACTION_VIDEO_CALL_TOGGLE_MIC":
          if (action.on) {
            HitagiSocket.media.talk();
          } else {
            HitagiSocket.media.mute();
          }
          break;
        case "PM_ACTION_VIDEO_TOGGLE_CAMERA":
          if (action.on) {
            HitagiSocket.media.cameraOn();
          } else {
            HitagiSocket.media.cameraOff();
          }
          break;
        case "PM_VIDEO_CALL_INFO":
          var oldVideoCall = store.getState().pm.conversations[action.conversation_uid].videoCall;
          if ((!oldVideoCall || oldVideoCall.state != 'connecting') && action.call.state == 'connecting' && oldVideoCall.local_connection && !oldVideoCall.incoming) {
            store.dispatch({
              type: "PM_VIDEO_CALL_GET_LOCAL_MEDIA_STREAM",
              conversation_uid: action.conversation_uid,
              call_id: action.call.call_id
            });
          }
          if ((!oldVideoCall || oldVideoCall.state != 'ended') && action.call.state == 'ended') {
            store.dispatch({
              type: "PM_VIDEO_CALL_CALL_ENDED",
              conversation_uid: action.conversation_uid,
              call_id: action.call.call_id,
              call: action.call
            });
          }
          if ((!oldVideoCall || !oldVideoCall.data.remote_stream) && action.call.data.remote_stream) {
            // start remote view

            HitagiSocket.stream.view({
              id: action.call.data.remote_stream,
              call_id: action.call.call_id
            }, function (RemoteStream) {
              store.dispatch({
                type: "PM_VIDEO_CALL_REMOTE_STREAM",
                stream: RemoteStream,
                conversation_uid: action.conversation_uid
              });
            });
          }
          console.log("oldVideoCall", oldVideoCall, action);
          break;
        case "PM_VIDEO_CALL_GET_LOCAL_MEDIA_STREAM":
          HitagiSocket.media.on_local_stream_success = on_local_stream_success(store, action.conversation_uid, action.call_id);
          var constraints = {
            "audio": true,
            "video": {
              "width": {
                "min": 320,
                "ideal": 640,
                "max": 1280
              },
              "height": {
                "min": 240,
                "ideal": 480,
                "max": 720
              }
            },
            "video_bitrate": 512,
            "audio_bitrate": 128
          };
          HitagiSocket.media.get_user_media(constraints).then(function (LocalMediaStream) {})["catch"](function (Event) {});
          break;
        case "PM_VIDEO_CALL_CALL_ENDED":
          HitagiSocket.media.stop();
          HitagiSocket.stream.leave(action.call.data.remote_stream);
          break;
      }
      return next(action);
    };
  };
};
var _default = pmMiddleware;
exports["default"] = _default;